import React, { useEffect, useRef, useState } from 'react';
import ProductSwiperLanding from 'react-ui-product-swiper-2';
import styleMd from './styles/selectorSwiper.module.scss';
import Selector from './selector.jsx';

const SelectableSwiper = ({items, selectors}) => {
    const [item, setItem] = useState(null);
    const [index, setIndex] = useState(0);
    const eleRef = useRef(null);

    useEffect(()=>{
        console.log(index);
        console.log(items[index]);
        if(!items[index]) return;
        setItem(items[index]);
        eleRef && eleRef.current.scrollIntoView({
            behavior: 'smooth'
        });
    }, [index])

    return (
        <section className={styleMd.container} ref={eleRef}>
            <ProductSwiperLanding products={item}/>
            <div className={styleMd.container__selector}>
                <Selector items={selectors} setFunc={setIndex}/>
            </div>
        </section>
    );
};

export default SelectableSwiper;